import React from 'react';
import { BookOpen, Users, FlaskConical } from 'lucide-react';
import { Divider } from './ui/Divider';
export function AuthoritySection() {
  const credentials = [{
    icon: <FlaskConical className="w-6 h-6" data-id="element-13" />,
    stat: '3+ Years',
    label: 'Of dedicated research into hormonal health for women 35–60'
  }, {
    icon: <BookOpen className="w-6 h-6" data-id="element-14" />,
    stat: '200+ Studies',
    label: 'Reviewed from endocrinology, nutrition, and circadian biology'
  }, {
    icon: <Users className="w-6 h-6" data-id="element-15" />,
    stat: '1,400+ Women',
    label: 'Have already used this protocol to reclaim their energy and clarity'
  }];
  return <section className="bg-sage-light py-24 px-6" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-18">
          <h2 className="text-4xl md:text-5xl mb-6" data-id="element-19">Why This Protocol Works</h2>
          <Divider className="mb-8" data-id="element-20" />
          <p className="text-lg md:text-xl text-warm-dark/80 leading-relaxed" data-id="element-21">
            This protocol was developed after 3 years of research into hormonal
            health for women 35–60 — combining insights from endocrinology,
            functional nutrition, and circadian science into one simple,
            kitchen-based system that works with your biology, not against it.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-22">
          {credentials.map((item, index) => <div key={index} className="bg-cream p-8 rounded-2xl border border-sage/10 text-center" data-id="element-23">
              <div className="w-14 h-14 rounded-full bg-sage/20 flex items-center justify-center text-olive-gold mx-auto mb-5" data-id="element-24">
                {item.icon}
              </div>
              <p className="text-3xl font-heading font-bold text-olive-gold mb-2" data-id="element-25">
                {item.stat}
              </p>
              <p className="text-warm-dark/70 leading-relaxed text-sm" data-id="element-26">
                {item.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}